import { ofType } from "redux-observable"
import { Action, ACTION_TYPES } from "../actions"
import { mergeMap } from "rxjs"
import { Service } from "../service"

export const fetchEpic = (action$) => action$.pipe(
    ofType(ACTION_TYPES.FETCH),
    mergeMap(({payload}) => {
        return Service.get(payload)
            .then(response => {
                return Action.fetchSuccess(response)
            })
    })
)


// WEBPACK FOOTER //
// ./src/state/project/epics/epics.ts